// Module
var code = `<div class="wrapper">
  <file-upload-new
    enable-webcam="false"
    on-files-added="\$ctrl.onFilesAdded(files)"
  >
  </file-upload-new>

  <textarea
    class="inline-editor"
    ng-model="\$ctrl.template"
    ng-change="\$ctrl.onTemplateChange()"
  >
  </textarea>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/prints/prints-details-template-upload.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;